enum NoYesNotApplicable {
    No = 0,
    Yes = 1,
    NotApplicable = 2
}

export { NoYesNotApplicable };
